<template>
  <div class="product-studio" dir="rtl">
    <div class="product-studio__ambient" aria-hidden="true"></div>

    <b-container fluid class="product-studio__shell px-0">
      <header class="studio-topbar" v-if="shortCreateFormComputed">
        <div class="studio-topbar__copy">
          <p class="studio-eyebrow">مدیریت فروشگاه</p>
          <h1 class="studio-title">{{ title || 'محصول' }}</h1>
        </div>

        <nav class="studio-topbar__actions">
      <m-a :href="{name:'ProductsDashboard'}">
            <button type="button" class="studio-chip">محصولات</button>
      </m-a>
      <m-a :href="{name:'StoreDashboardProducts'}">
            <button type="button" class="studio-chip">محصولات انبار</button>
      </m-a>
      <template v-if="checkBasalamShowConfigButton">
        <m-a :href="{name:'productBasalamSetting',params:{id:$route.params.slug}}">
              <button type="button" class="studio-chip studio-chip--accent">تنظیمات باسلام</button>
        </m-a>
      </template>
        </nav>
      </header>

      <b-form class="studio-form" @submit.prevent="onSubmit">
        <header class="studio-pagehead" v-if="!shortCreateFormComputed">
          <h1 class="studio-title">{{ title || 'محصول' }}</h1>
        </header>

        <!-- Basics -->
        <section class="studio-panel">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="card-heading"/></span>
                اطلاعات پایه
              </h2>
              <p class="studio-panel__hint">نام، لینک و وضعیت انتشار محصول</p>
            </div>
            <span class="studio-step">۱</span>
          </div>

          <div class="studio-panel__body">
            <div class="studio-basics" :class="{ 'studio-basics--with-side': $route.params.slug != undefined }">
              <div class="studio-basics__main">
      <name-and-link-manager
          :router-link="{ name: 'Product', params: { name: form.nameAndLink.link } }"
          :label="'نام محصول'"
          v-model="form.nameAndLink"
          :validation="$v.form.nameAndLink.name">
                  <div class="studio-status-row" v-if="shortCreateFormComputed">
                    <div class="studio-status-chip">
                      <published-checkbox label="وضعیت انتشار" v-model="form.published"/>
                    </div>
                    <div class="studio-status-chip studio-status-chip--digital">
                      <published-checkbox label="محصول دیجیتال است؟" v-model="form.is_digital"/>
                    </div>
                  </div>
      </name-and-link-manager>
              </div>

              <aside class="studio-basics__side" v-if="$route.params.slug != undefined">
                <div class="studio-qr-card">
                  <div class="studio-qr-card__preview">
                    <qr-generator
                        :qr-value="dashboardLinkToSiteLink('Product',{name:form.nameAndLink.link})"/>
                  </div>
                  <div class="studio-qr-card__meta">
                    <p class="studio-qr-card__title">QR محصول</p>
                    <p class="studio-qr-card__hint">برای چاپ یا اشتراک لینک محصول</p>
                    <button
                        v-if="shortCreateFormComputed"
                        type="button"
                        class="studio-ghost-btn"
            @click="copyToClipBoard(`${findAttributeOnSiteInfo('host')[0]}/api/s/p-${form.id}`)">
        <b-icon-link45deg/>
                      کپی لینک کوتاه
                    </button>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <!-- Media -->
        <section class="studio-panel">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="images"/></span>
                رسانه محصول
              </h2>
              <p class="studio-panel__hint">تصویر اصلی و گالری عکس‌ها</p>
            </div>
            <span class="studio-step">۲</span>
          </div>

          <div class="studio-panel__body">
            <div class="studio-media-grid">
              <div class="studio-media-block studio-media-block--main">
                <h3 class="studio-subtitle">
                  <span class="studio-media-icon"><b-icon icon="image"/></span>
                  تصویر اصلی
                </h3>
                <single-image
                    v-model="form.mainImage"
                    :mainPreview="form.mainPreview"
                    :validation="$v.form.mainImage"
                    :allowed-extensions="allowedProductImageFormats"
                    @invalid-image="onInvalidProductImage"/>
      </div>
              <div class="studio-media-block studio-media-block--gallery mb-2">
                <h3 class="studio-subtitle">
                  <span class="studio-media-icon"><b-icon icon="images"/></span>
                  گالری تصاویر
                </h3>
                <multi-image-input
                    @removeImage="removeImage"
                    @removeTempImage="removeTempImage"
                    @images="setImages"
                    @invalid-image="onInvalidProductImage"
                    :allowed-extensions="allowedProductImageFormats"
                    :previews="form.preview"/>
              </div>
            </div>
          </div>
        </section>

        <!-- Classification -->
        <section class="studio-panel">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="folder2-open"/></span>
                دسته‌بندی و هویت
              </h2>
              <p class="studio-panel__hint">برند، زبان، دسته و تگ‌ها</p>
            </div>
            <span class="studio-step">۳</span>
          </div>

          <div class="studio-panel__body">
            <div class="studio-identity-grid" v-if="shortCreateFormComputed">
              <div class="studio-picker-card">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">برند</h3>
                    <p class="studio-panel__hint mb-0">یک برند برای محصول انتخاب کنید</p>
                  </div>
                  <div class="studio-picker-card__tools">
                    <button type="button" class="studio-mini-btn" v-b-modal.create-product-brand title="افزودن برند">
                      <b-icon icon="plus"/>
                    </button>
                    <button type="button" class="studio-mini-btn" @click="$store.dispatch('Brand/getBrands')">
                      <b-icon icon="arrow-clockwise"/>
                    </button>
                  </div>
                </div>

                <div class="studio-picker-card__selected" v-if="form.selectedBrand && form.selectedBrand.name">
                  <button type="button" class="studio-tag studio-tag--primary" @click="clearSelectedBrand">
                    {{ form.selectedBrand.name }}
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <p class="studio-tags__empty" v-else>هنوز برندی انتخاب نشده است.</p>

                <div class="studio-picker-card__body">
                  <brand
                      :brands="brands"
                      v-model="form.selectedBrand"
                      :validation="$v.form.selectedBrand"/>
                </div>
              </div>

              <div class="studio-picker-card">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">زبان</h3>
                    <p class="studio-panel__hint mb-0">زبان نمایش محصول</p>
                  </div>
                  <button type="button" class="studio-mini-btn" @click="$store.dispatch('Language/getLanguages')">
                    <b-icon icon="arrow-clockwise"/>
                  </button>
                </div>

                <div class="studio-picker-card__body">
                  <languageBox
                      v-model="form.language_id"
                      :validation="$v.form.language_id"/>
                </div>
              </div>

              <div class="studio-picker-card">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">دسته‌بندی</h3>
                    <p class="studio-panel__hint mb-0">دسته و زیردسته را از درخت انتخاب کنید</p>
                  </div>
                  <div class="studio-picker-card__tools">
                    <button type="button" class="studio-mini-btn" v-b-modal.create-product-category title="افزودن دسته">
                      <b-icon icon="plus"/>
                    </button>
                    <button type="button" class="studio-mini-btn" @click="$store.dispatch('Category/getDashboardCategories')">
                      <b-icon icon="arrow-clockwise"/>
                    </button>
                  </div>
                </div>

                <div class="studio-picker-card__selected" v-if="form.selectedCategory && form.selectedCategory.length">
                  <button
                      type="button"
                      class="studio-tag"
                      v-for="(item,index) in form.selectedCategory"
                      :key="item.id || index"
                      @click="removeSelectedCategory(index)">
                    {{ item.name }}
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <p class="studio-tags__empty" v-else>هنوز دسته‌ای انتخاب نشده است.</p>

                <div class="studio-picker-card__body studio-picker-card__body--category">
                  <check-box-manager
                      :CheckBoxItems="categories"
                      label="انتخاب دسته بندی"
                      :selectedCheckBoxes="form.selectedCategory"
                      :validation="$v.form.selectedCategory"/>
                </div>
              </div>

              <div class="studio-picker-card">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">تگ‌ها</h3>
                    <p class="studio-panel__hint mb-0">برای حذف، روی تگ کلیک کنید</p>
                  </div>
                  <div class="studio-picker-card__tools">
                    <button type="button" class="studio-mini-btn" v-b-modal.create-product-tag title="افزودن تگ">
                      <b-icon icon="plus"/>
                    </button>
                    <button type="button" class="studio-mini-btn" @click="refreshProductTags">
                      <b-icon icon="arrow-clockwise"/>
                    </button>
                  </div>
                </div>

                <div class="studio-picker-card__selected" v-if="form.tags && form.tags.length">
                  <button
                      type="button"
                      class="studio-tag"
                      v-for="(item,index) in form.tags"
                      :key="item.id"
                      @click="removeTag(index)">
                    {{ item.name }}
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <p class="studio-tags__empty" v-else>هنوز تگی انتخاب نشده است.</p>

                <div class="studio-picker-card__body">
                  <tag-user ref="productTagUser" tag-type="product" @selectedTags="setProductTags"/>
                </div>
              </div>

              <div
                  class="studio-picker-card"
                  v-if="form.variation == 0 && this.$route.params.slug !== undefined && form.id != null">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">اشتراک‌های محصول</h3>
                    <p class="studio-panel__hint mb-0">با انتخاب اشتراک، قیمت از همان اشتراک محاسبه می‌شود</p>
                  </div>
                  <button
                      type="button"
                      class="studio-mini-btn"
                      @click="refreshProductSubscriptions">
                    <b-icon icon="arrow-clockwise"/>
                  </button>
                </div>

                <div class="studio-picker-card__selected" v-if="form.subscriptions && form.subscriptions.length">
                  <button
                      type="button"
                      class="studio-tag studio-tag--primary"
                      v-for="item in form.subscriptions"
                      :key="item.id"
                      @click="removeProductSubscription(item)">
                    {{ item.subscription.name }} {{ item.subscription_item.name }}
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <p class="studio-tags__empty" v-else>هنوز اشتراکی انتخاب نشده است.</p>

                <div class="studio-picker-card__body studio-picker-card__body--subscription">
                  <product-subscription-manager ref="productSubscriptions" :product="form" :embedded="true"/>
                </div>
              </div>
            </div>

            <div
                class="studio-identity__extra"
                v-if="checkServiceIsExpire('multiple_store_module') && Object.keys(form).length > 0">
              <div class="studio-picker-card studio-picker-card--collapse">
                <div class="studio-picker-card__head">
                  <div>
                    <h3 class="studio-subtitle mb-0">فروشگاه‌های محصول</h3>
                    <p class="studio-panel__hint mb-0">فروشگاه‌های مرتبط با این محصول را انتخاب کنید</p>
                  </div>
                  <div class="studio-picker-card__tools">
                    <button
                        type="button"
                        class="studio-mini-btn"
                        title="بروزرسانی"
                        @click="refreshProductStores">
                      <b-icon icon="arrow-clockwise"/>
                    </button>
                    <button type="button" class="studio-soft-btn" v-b-toggle.product-stores-collapse>
                      نمایش
                    </button>
                  </div>
                </div>

                <div class="studio-picker-card__selected" v-if="form.product_multiple_store && form.product_multiple_store.length">
                  <button
                      type="button"
                      class="studio-tag studio-tag--primary"
                      v-for="(item, index) in form.product_multiple_store"
                      :key="item.id || (item.user && item.user.id) || index"
                      @click="removeProductStore(item)">
                    {{ item.user && item.user.name }}
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <p class="studio-tags__empty" v-else>هنوز فروشگاهی انتخاب نشده است.</p>

                <b-collapse id="product-stores-collapse">
                  <div class="studio-picker-card__body studio-picker-card__body--stores">
                    <product-multiple-store
                        ref="productMultipleStore"
                        :product="form"
                        :embedded="true"/>
                  </div>
                </b-collapse>
              </div>
            </div>

            <div v-if="!shortCreateFormComputed" class="studio-picker-card studio-picker-card--auto">
              <languageBox
                  v-model="form.language_id"
                     :validation="$v.form.language_id"/>
            </div>

            <b-modal
                id="create-product-category"
                title="افزودن دسته‌بندی"
                size="lg"
                hide-footer
                centered>
              <div class="studio-category-modal" dir="rtl">
                <p class="studio-panel__hint mb-3">
                  دسته اصلی یا زیردسته جدید بسازید. برای زیردسته، دسته والد را انتخاب کنید.
                </p>
                <quick-category-create @created="onProductCategoryCreated"/>
        </div>
            </b-modal>

            <b-modal
                id="create-product-brand"
                title="افزودن برند"
                size="lg"
                hide-footer
                centered>
              <div class="studio-category-modal" dir="rtl">
                <quick-brand-create @created="onProductBrandCreated"/>
        </div>
            </b-modal>

            <b-modal
                id="create-product-tag"
                title="افزودن تگ"
                size="lg"
                hide-footer
                centered>
              <div class="studio-category-modal" dir="rtl">
                <quick-tag-create @created="onProductTagCreated"/>
              </div>
            </b-modal>
          </div>
        </section>

        <!-- Pricing -->
        <section class="studio-panel">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="cash-stack"/></span>
                قیمت و موجودی
              </h2>
              <p class="studio-panel__hint">مبالغ، موجودی و ترتیب نمایش</p>
            </div>
            <span class="studio-step">۴</span>
          </div>

          <div class="studio-panel__body">
            <div class="studio-fields">
              <div class="studio-field" v-if="form.variation==0">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.price"
                    label="قیمت"
                      :validation="$v.form.price"/>
                <span class="studio-field__preview" v-if="form.price">{{ formatNumber(form.price) }}</span>
              </div>

              <div class="studio-field" v-if="form.variation==0">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.quantity"
                    label="تعداد موجود در انبار"
                      :validation="$v.form.quantity"/>
                <span class="studio-field__preview" v-if="form.quantity">{{ formatNumber(form.quantity) }}</span>
                <p class="studio-field__note">خالی بگذارید تا موجودی نامحدود شود.</p>
              </div>

              <div class="studio-field" v-if="!form.is_digital && shortCreateFormComputed">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.shippingCost"
                    label="هزینه ارسال"
                      :validation="$v.form.shippingCost"/>
                <span class="studio-field__preview" v-if="form.shippingCost">{{ formatNumber(form.shippingCost) }}</span>
                <p class="studio-field__note">در صورت خالی بودن، از تنظیمات سفارش استفاده می‌شود.</p>
              </div>

              <div class="studio-field" v-if="!form.is_digital && shortCreateFormComputed">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.additionalPackagingAmount"
                    label="هزینه اضافه بسته‌بندی"
                      :validation="$v.form.additionalPackagingAmount"/>
                <span class="studio-field__preview" v-if="form.additionalPackagingAmount">{{ formatNumber(form.additionalPackagingAmount) }}</span>
                <p class="studio-field__note">این مبلغ به ازای هر تعداد، به هزینه بسته‌بندی اضافه می‌شود .</p>
              </div>

              <div class="studio-field" v-if="form.variation==0 && shortCreateFormComputed">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.discount"
                    label="تخفیف"
                      :validation="$v.form.discount"
                      @input="calculatePercentOfDiscount"/>
                <span class="studio-field__preview" v-if="form.discount">{{ formatNumber(form.discount) }}</span>
              </div>

              <div class="studio-field" v-if="form.variation===0 && shortCreateFormComputed">
          <form-input
              :validation="$v.form.discountPercentage"
              :custom_class_on_input="`text-left`"
              v-model="form.discountPercentage"
              @input="calculateDiscount"
                    label="درصد تخفیف"/>
              </div>

              <div class="studio-field" v-if="shortCreateFormComputed">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.bonus"
                    label="پرداخت اضافی"
                    :validation="$v.form.bonus"/>
                <span class="studio-field__preview" v-if="form.bonus">{{ formatNumber(form.bonus) }}</span>
              </div>

              <div class="studio-field" v-if="shortCreateFormComputed">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.order"
                    label="ترتیب"
                    :validation="$v.form.order"/>
                <span class="studio-field__preview" v-if="form.order">{{ formatNumber(form.order) }}</span>
                <p class="studio-field__note">برای ترتیب دلخواه از عدد ۲ شروع کنید.</p>
              </div>

              <div class="studio-field">
                <form-input v-model="form.barcode" label="بارکد" :validation="$v.form.barcode"/>
              </div>
            </div>
          </div>
        </section>

        <!-- Dimensions -->
        <section class="studio-panel">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="box-seam"/></span>
                ابعاد و وزن
              </h2>
              <p class="studio-panel__hint">برای محاسبه ارسال و بسته‌بندی</p>
            </div>
            <span class="studio-step">۵</span>
          </div>

          <div class="studio-panel__body">
            <div class="studio-fields studio-fields--compact">
              <div class="studio-field">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.length"
                    label="طول (سانتی‌متر)"
                    :validation="$v.form.length"/>
              </div>
              <div class="studio-field">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.width"
                    label="عرض (سانتی‌متر)"
                    :validation="$v.form.width"/>
              </div>
              <div class="studio-field">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.height"
                    label="ارتفاع (سانتی‌متر)"
                      :validation="$v.form.height"/>
              </div>
              <div class="studio-field">
                <form-input
                    :custom_class_on_input="`text-left`"
                    v-model="form.weight"
                    label="وزن (گرم)"
                      :validation="$v.form.weight"/>
              </div>
            </div>
          </div>
        </section>

        <!-- Content -->
        <section class="studio-panel" v-if="shortCreateFormComputed">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="file-richtext"/></span>
                محتوا
              </h2>
              <p class="studio-panel__hint">چکیده و توضیحات کامل محصول</p>
            </div>
            <span class="studio-step">۶</span>
          </div>

          <div class="studio-panel__body">
            <button type="button" class="studio-soft-btn" v-b-toggle.collapse-1>
              تعریف چکیده
            </button>

            <b-collapse id="collapse-1" class="studio-collapse">
          <form-group :validations="$v.form.abstract" class="w-100">
                <div slot-scope="{ errors }">
                  <label class="studio-label">چکیده</label>
                  <div class="studio-editor">
                    <div class="studio-editor__bar">
                      <span class="studio-editor__bar-label">افزودن iframe</span>
                      <add-iframe-to-editor @iframe-handler="(html) => appendIframe('abstract', html)"/>
                    </div>
                    <div class="studio-editor__canvas">
                <vue2-tinymce-editor v-model="form.abstract" :options="defaultToolbar"></vue2-tinymce-editor>
                    </div>
              </div>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-collapse>

            <form-group :validations="$v.form.description" class="w-100 studio-description">
              <div slot-scope="{ errors }">
                <label class="studio-label">توضیحات</label>
                <div class="studio-editor">
                  <div class="studio-editor__bar">
                    <span class="studio-editor__bar-label">افزودن iframe</span>
                    <add-iframe-to-editor @iframe-handler="(html) => appendIframe('description', html)"/>
                  </div>
                  <div class="studio-editor__canvas">
              <vue2-tinymce-editor v-model="form.description" :options="defaultToolbar"></vue2-tinymce-editor>
                  </div>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
          </div>
        </section>

        <!-- Variation -->
        <section class="studio-panel" v-if="shortCreateFormComputed">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="diagram-3"/></span>
                نوع محصول
              </h2>
              <p class="studio-panel__hint">ساده، متغیر یا زمان‌دار</p>
        </div>
            <span class="studio-step">۷</span>
          </div>

          <div class="studio-panel__body">
            <label class="studio-label studio-label--link" :for="`variation`" v-b-modal="`produc-variation-info`">
            نوع محصول
            <b-icon icon="info-circle-fill"/>
          </label>

            <select
                id="variation"
                class="studio-select"
                v-model="form.variation"
                @change="variationSwitchChange">
            <option value="0">معمولی</option>
              <option value="1">متغیر</option>
            <option value="2">زمان دار</option>
          </select>

            <button
                type="button"
                class="studio-danger-btn mt-3"
               v-if="form.variation == 1 && checkServiceIsExpire('is_product_variation_module_expire')"
                v-b-modal.variation-product>
              اضافه کردن متغیر
            </button>
          </div>
        </section>

        <b-modal id="produc-variation-info" hide-footer>
          <div class="text-right studio-modal" dir="rtl">
            <h5>محصول ساده</h5>
            <p class="mb-3">برای تمامی کاربران فعال است و شامل امکانات پایه می‌باشد.</p>

            <h5>محصول متغیر</h5>
            <p class="mb-3">امکان ساخت متغیرهایی مثل رنگ، سایز و حافظه را می‌دهد.</p>

            <h5>محصول زمان‌دار</h5>
            <p class="mb-3">مناسب نوبت‌دهی و فروش بر اساس زمان.</p>

            <hr>
            <p>برای فعال‌سازی هر مورد به بخش ماژول‌ها مراجعه کنید.</p>
            <div class="text-center">
              <button type="button" class="studio-primary-btn w-75 mx-auto">مشاهده لیست ماژول‌ها</button>
            </div>
          </div>
        </b-modal>

        <b-modal id="variation-product" hide-footer size="lg" dir="rtl">
          <variation-feature-generator :product="form"/>
        </b-modal>

        <section class="studio-panel" v-if="showFeatureManager && shortCreateFormComputed">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="ui-checks-grid"/></span>
                ویژگی‌ها
              </h2>
              <p class="studio-panel__hint">ویژگی‌های فنی و فروش محصول</p>
            </div>
            <span class="studio-step">۸</span>
          </div>
          <div class="studio-panel__body">
            <features-manager :product="form" :features="form.features"/>
          </div>
        </section>

        <section class="studio-panel" v-if="shortCreateFormComputed">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="tags"/></span>
                کلمات کلیدی
              </h2>
              <p class="studio-panel__hint">برای جستجو و سئو</p>
      </div>
            <span class="studio-step">۹</span>
          </div>
          <div class="studio-panel__body">
            <key-words-manager :keyWords="form.keyWords" :TableItems="form.table"/>
          </div>
        </section>

        <section
            class="studio-panel"
            v-if="form.variation == 2 && this.$route.params.slug !== undefined">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="calendar2-week"/></span>
                رزرو و زمان‌بندی
              </h2>
              <p class="studio-panel__hint">قوانین و بازه‌های زمانی</p>
            </div>
            <span class="studio-step">۱۰</span>
          </div>
          <div class="studio-panel__body">
            <reservation
                :product="form.id"
                :reservationRule="reservationRule"
                :reservationTimes="reservationTimes"/>
          </div>
        </section>

        <!-- Bulk -->
        <section
            class="studio-panel"
            v-if="form.variation == 0 && this.$route.params.slug !== undefined">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="graph-up-arrow"/></span>
                محدودیت فروش
              </h2>
              <p class="studio-panel__hint">بازه قیمت و تخفیف پلکانی</p>
            </div>
            <div class="studio-panel__tools">
              <button type="button" class="studio-soft-btn" v-b-toggle.bulk>نمایش</button>
              <button type="button" class="studio-icon-btn" v-b-modal.create-bulk>+</button>
            </div>
          </div>

          <b-collapse id="bulk" class="studio-panel__body">
            <div class="studio-table-wrap">
              <table class="studio-table">
          <thead>
          <tr>
            <th scope="col">شروع بازه</th>
            <th scope="col">پایان بازه</th>
            <th scope="col">قیمت</th>
            <th scope="col">تخفیف</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <bulk-item v-for="item in bulks" :key="item.id" :item="item"/>
          </tbody>
        </table>
            </div>
      </b-collapse>
        </section>

      <b-modal id="create-bulk" hide-footer>
        <div class="text-right">
          <bulk-form :product_id="form.id"/>
        </div>
      </b-modal>

        <!-- Crawler -->
        <section class="studio-panel" v-if="this.$route.params.slug !== undefined">
          <div class="studio-panel__head">
            <div>
              <h2 class="studio-panel__title">
                <span class="studio-panel__title-icon"><b-icon icon="link-45deg"/></span>
                Crawler
              </h2>
              <p class="studio-panel__hint">واکشی خودکار اطلاعات از لینک‌ها</p>
            </div>
            <div class="studio-panel__tools">
              <button type="button" class="studio-soft-btn" v-b-toggle.crawler>نمایش</button>
              <button type="button" class="studio-icon-btn" v-b-modal.create-crawler>+</button>
            </div>
      </div>

      <b-modal id="create-crawler" hide-footer>
        <div class="text-right">
          <crawler-form crawler-type="product" :product="form" :crawlerable-id="form.id"/>
        </div>
      </b-modal>

          <b-collapse id="crawler" class="studio-panel__body">
            <div class="studio-table-wrap">
              <table class="studio-table">
          <thead>
          <tr>
            <th scope="col">لینک</th>
            <th scope="col">xpath</th>
            <th scope="col">محل قرارگیری</th>
            <th scope="col">#</th>
          </tr>
          </thead>
          <tbody>
          <crawler-item v-for="item in crawlers" :key="item.id" :product="form" :item="item"/>
          </tbody>
        </table>
            </div>
      </b-collapse>
        </section>

        <!-- Actions -->
        <div
            class="studio-actions"
            :class="{ 'studio-actions--single': $route.params.slug != undefined }"
            v-if="shortCreateFormComputed">
          <button type="submit" class="studio-primary-btn">ثبت محصول</button>
          <button
              v-if="this.$route.params.slug == undefined"
              @click="submitAndCreateNew()"
              type="button"
              class="studio-secondary-btn">
          ثبت و ساخت جدید
          </button>
        </div>

        <div class="studio-actions studio-actions--single" v-else-if="this.$route.params.slug == undefined">
          <button type="submit" class="studio-primary-btn">
          ثبت و ساخت جدید
          </button>
        </div>
    </b-form>
  </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import router from '@/router';
import {required, numeric, minValue, maxValue, integer} from "vuelidate/lib/validators";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import category from "./category";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import SingleImage from "../Content/FormItems/SingleImage.vue";
import RadioBox from "../Content/FormItems/RadioBox.vue";
import CheckBoxManager from "../Content/FormItems/CheckBoxManager.vue";
import FormInput from "../Content/FormItems/FormInput.vue";
import FormTextArea from "../Content/FormItems/FormTextArea.vue";
import FeaturesManager from "../Content/FormItems/FeaturesManager.vue";
import KeyWordsManager from "../Content/FormItems/KeyWordsManager.vue";
import NameAndLinkManager from "../Content/FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "../Content/FormItems/PublishedCheckbox.vue";
import VariationFeatureGenerator from "./productFeatureComponents/VariationFeatureGenerator.vue";
import AddIframeToEditor from "../Content/FormItems/AddIframeToEditor";
import Brand from './Brand'
import MultiImageInput from './MultiImageInput'
import CrawlerItem from '../Crawler/CrawlerItem'
import CrawlerForm from '../Crawler/CrawlerForm'
import BulkItem from '../Bulk/BulkItem'
import BulkForm from '../Bulk/BulkForm'
import languageBox from "../Language/LanguageBox";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import Reservation from "../Reservation/Reservation.vue";

import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import QrGenerator from "@/plugin/components/genralComponents/QrGenerator.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import ProductSubscriptionManager from "./ProductSubscriptionManager.vue";
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";
import ProductMultipleStore from "@/plugin/components/dashboard/product/ProductMultipleStore.vue";
import TagUser from "@/plugin/components/dashboard/User/TagUser.vue";
import QuickCategoryCreate from "@/plugin/components/dashboard/product/QuickCategoryCreate.vue";
import QuickBrandCreate from "@/plugin/components/dashboard/product/QuickBrandCreate.vue";
import QuickTagCreate from "@/plugin/components/dashboard/product/QuickTagCreate.vue";

export default {
  name: "CreateProductLayout",
  components: {
    QuickTagCreate,
    QuickBrandCreate,
    QuickCategoryCreate,
    TagUser,
    ProductMultipleStore,
    ProductSubscriptionManager,
    VariationFeatureGenerator,
    QrGenerator,
    category,
    FormGroup,
    FormErrorsManager,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    FeaturesManager,
    KeyWordsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    Brand,
    MultiImageInput,
    CrawlerItem,
    CrawlerForm,
    BulkItem,
    BulkForm,
    languageBox,
    AddIframeToEditor,
    Vue2TinymceEditor,
    Reservation,
  },
  props: {
    title: {},
    submitFunction: {},
    shortCreateForm: {
      default: false
    },
  },
  data() {
    return {
      showFeatureManager: true,
      featureVariation: [],
      selectedFeatureVariation: [],
      allowedProductImageFormats: ['jpeg', 'jpg', 'JPG', 'png', 'bmp', 'gif', 'svg', 'webp', 'avif'],
      form: {
        images: [],
        mainImage: [],
        mainPreview: "",
        preview: [],
        selectedBrand: "",
        selectedCategory: [],
        selectedFeature: [],
        price: null,
        quantity: null,
        shippingCost: null,
        additionalPackagingAmount: null,
        discount: null,
        published: false,
        description: "",
        abstract: "",
        id: "",
        keyWords: [],
        nameAndLink: {name: "", link: ""},
        is_digital: false,
        variation: 0,
        bonus: 0,
        order: 0,
        language_id: '',
        barcode: '',
        table: [],
        features: [],
        discountPercentage: 0,
        subscriptions: [],
        length: null,
        width: null,
        height: null,
        weight: null,
        product_multiple_store: [],
        tags: [],
      },
      defaultToolbar,
    };
  },
  validations() {
    if (this.shortCreateForm) {
      return {
        form: {
          nameAndLink: {name: {required}},
          selectedBrand: {},
          selectedCategory: {},
          items: {},
          price: {numeric},
          quantity: {numeric},
          shippingCost: {numeric},
          additionalPackagingAmount: {numeric},
          discount: {numeric},
          bonus: {numeric},
          order: {numeric, minValue: minValue(0)},
          language_id: {required},
          barcode: {},
          description: {},
          abstract: {},
          variation: {},
          mainImage: {},
          discountPercentage: {numeric, minValue: minValue(0), maxValue: maxValue(100)},
        }
      }
    }

    return {
      form: {
        nameAndLink: {name: {required}},
        selectedBrand: {},
        selectedCategory: {},
        items: {},
        price: {numeric},
        quantity: {numeric},
        shippingCost: {numeric},
        additionalPackagingAmount: {numeric},
        discount: {numeric},
        bonus: {required, numeric},
        order: {required, numeric, minValue: minValue(0)},
        language_id: {required},
        barcode: {},
        description: {},
        abstract: {},
        variation: {},
        mainImage: {},
        discountPercentage: {minValue: minValue(0), maxValue: maxValue(100)},
        length: {},
        width: {},
        height: {},
        weight: {},
      }
    }
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      brands: "Brand/getBrands",
      features: "Feature/getFilteredFeatures",
      crawlers: "Crawler/getCrawlers",
      bulks: "Bulk/getBulks",
      reservationRule: "Reservation/getReservationRule",
      reservationTimes: "Reservation/getReservationTimes",
    }),
    shortCreateFormComputed() {
      return !this.shortCreateForm
    },
    checkBasalamShowConfigButton() {
      return this.$route.params.slug !== undefined && findAttributeOnSiteInfo('basalam_token')[0] != '' && this.checkServiceIsExpire('basalam')
    }
  },
  methods: {
    checkServiceIsExpire,
    formatNumber,
    findAttributeOnSiteInfo,
    setProductTags(data) {
      let tags = data.tags;
      if (!this.form.tags) {
        this.form.tags = [];
      }
      if (!this.form.tags.find(item => item.id === tags.id)) {
        this.form.tags.push(tags);
      }
    },
    removeTag(index) {
      if (confirm('ایا از حذف اطمینان دارید؟')) {
        this.form.tags.splice(index, 1);
      }
    },
    clearSelectedBrand() {
      if (confirm('از حذف برند محصول اطمینان دارید؟')) {
        this.form.selectedBrand = '';
      }
    },
    removeSelectedCategory(index) {
      if (confirm('از حذف این دسته اطمینان دارید؟')) {
        this.form.selectedCategory.splice(index, 1);
      }
    },
    onProductCategoryCreated() {
      this.$store.dispatch('Category/getDashboardCategories')
      this.$bvModal.hide('create-product-category')
    },
    onProductBrandCreated() {
      this.$store.dispatch('Brand/getBrands')
      this.$bvModal.hide('create-product-brand')
    },
    onProductTagCreated() {
      this.refreshProductTags()
      this.$bvModal.hide('create-product-tag')
    },
    refreshProductTags() {
      if (this.$refs.productTagUser && this.$refs.productTagUser.getTags) {
        this.$refs.productTagUser.getTags()
      }
    },
    refreshProductStores() {
      if (this.$refs.productMultipleStore && this.$refs.productMultipleStore.refreshStores) {
        this.$refs.productMultipleStore.refreshStores()
      }
    },
    removeProductStore(item) {
      if (!confirm('آیا از حذف اطمینان دارید؟')) {
        return
      }
      const productStores = this.form.product_multiple_store || []
      let indexOfItem = productStores.map(row => row.id).indexOf(item.id)
      if (indexOfItem === -1) {
        indexOfItem = productStores.map(row => row.user && row.user.id).indexOf(item.user && item.user.id)
      }
      if (indexOfItem > -1) {
        productStores.splice(indexOfItem, 1)
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      }
    },
    refreshProductSubscriptions() {
      if (this.$refs.productSubscriptions) {
        this.$refs.productSubscriptions.refreshSubscriptions()
      }
    },
    removeProductSubscription(item) {
      if (!confirm('آیا از حذف اطمینان دارید؟')) {
        return
      }
      this.$store.dispatch('Subscription/deleteProductSubscription', item).then(() => {
        const indexOfItem = (this.form.subscriptions || []).map(row => row.id).indexOf(item.id)
        if (indexOfItem > -1) {
          this.form.subscriptions.splice(indexOfItem, 1)
        }
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.shortCreateForm) {
        this.submitAndCreateNew()
        return false
      }
      this.submitAndPush()
    },
    submitAndPush() {
      if (this.invalid()) {
        let form = {};

        form = {
          name: this.form.nameAndLink.name,
          link: this.form.nameAndLink.link,
          ...this.form,
        };
        this.submitFunction(form)
            .then((res) => {
              const product = res.data.data;
              if (this.$router.currentRoute.params.slug !== product.raw_link) {
                router.push({
                  name: "EditProduct",
                  params: {slug: product.raw_link},
                });
              }
              if (this.$route.params.slug !== undefined) {
                this.form.images = []
                this.setComponentForm('all')
                this.$store.commit("Product/setProduct", product);
              }
              toast('محصول با موفقیت ثبت شد.', 'محصول با موفقیت ثبت شد.', 'success')
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    submitAndCreateNew() {
      if (this.invalid()) {
        let form = {};


        form = {
          name: this.form.nameAndLink.name,
          link: this.form.nameAndLink.link,
          ...this.form,
        };

        this.submitFunction(form)
            .then((res) => {
              const product = res.data.data;
              toast('محصول با موفقیت ثبت شد.', 'محصول با موفقیت ثبت شد.', 'top')
              this.$emit('refreshComponent')
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    async setComponentForm(mode = 'all') {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      document.getElementById(`language_item_${language_id}`).click();

      this.form.nameAndLink.link = this.$route.params.slug;
      this.$store
          .dispatch("Product/getDashboardProduct", this.form.nameAndLink.link)
          .then(async (res) => {

            res = res.data.data

            language_id = await res.language_id;
            document.getElementById(`language_item_${language_id}`).click();
            this.form.table = []
            this.form.keyWords = []
            if (mode === 'all') {

              this.form.nameAndLink.name = await res.name;
              this.form.id = await res.id;
              this.form.nameAndLink.link = await res.raw_link;
              this.form.published = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.price = await res.price;
              this.form.bonus = await res.bonus;
              this.form.order = await res.order;
              this.form.quantity = await res.quantity;
              this.form.shippingCost = await res.delivery_amount;
              this.form.additionalPackagingAmount = await res.additional_delivery_amount;
              this.form.discount = await res.offer;
              this.form.is_digital = await res.is_digital == 1 ? true : false;
              this.form.variation = await res.variation;

              this.form.length = await res.length;
              this.form.width = await res.width;
              this.form.height = await res.height;
              this.form.weight = await res.weight;
              this.form.product_multiple_store = await res.product_multiple_store;
              this.form.tags = res.tags || [];


              if (res.description == null) {
                this.form.description = "";
              } else {
                this.form.description = await res.description;
              }

              if (res.abstract == null) {
                this.form.abstract = "";
              } else {
                this.form.abstract = await res.abstract;
              }

              if (res.barcode == null) {
                this.form.barcode = "";
              } else {
                this.form.barcode = await res.barcode;
              }


              if (res.brand == null) {
                this.form.selectedBrand = '';
              } else {
                this.form.selectedBrand = await res.brand;

              }

              this.form.selectedCategory = []

              await res.category.forEach((category) => {
                this.form.selectedCategory.push(category)
              });

              this.form.features = await res.feature_product

              this.form.subscriptions = await res.subscriptions

              this.form.images = []
              this.form.preview = []
              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });

              await res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });


              const crawlerForm = {
                crawlerable_id: res.id,
                crawlerable_type: 'product',
              }

              await this.$store.dispatch("Crawler/getCrawlers", crawlerForm);

              if (res.variation == 2) { // if product was timable
                const ReservationForm = {
                  product: res.id,
                  month: this.$store.getters['Reservation/getMonth'],
                  year: this.$store.getters['Reservation/getYear'],
                  withoutState: false,
                }

                let DashboardProductRules = await this.$store.dispatch("Reservation/getDashboardProductRules", ReservationForm);
                let reservationTimes = DashboardProductRules.data.data.reservation_times
                this.$store.commit('Reservation/setReservationTimes', reservationTimes)
              }

              if (res.variation == 0) {
                this.calculatePercentOfDiscount()
              }


              const bulkForm = {
                product_id: res.id,
              }
              await this.$store.dispatch("Bulk/getBulks", bulkForm);

            }


            if (mode === 'image') {
              this.form.images = []
              this.form.preview = []
              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });

              this.form.order = await res.order;

            }

          })
          .catch((err) => {
            // this.$router.push({name: "ProductsDashboard"});
            console.log(err);
          });
    },
    imageHandlerFunction(image) {
      this.form.description += image;
    },
    videoHandlerFunction(video) {
      this.form.description += video;
    },
    iframeHandlerFunction(iframe) {
      this.appendIframe('description', iframe);
    },
    appendIframe(field, iframe) {
      if (!this.form[field]) {
        this.form[field] = '';
      }
      this.form[field] += iframe;
    },
    removeImage() {
      this.setComponentForm('image')
    },
    getProductImageExtension(file) {
      const name = (file && file.name) ? file.name : ''
      const parts = name.split('.')
      if (parts.length < 2) {
        return ''
      }
      return parts[parts.length - 1]
    },
    isAllowedProductImage(file) {
      if (!file || !file.name) {
        return false
      }
      const ext = this.getProductImageExtension(file)
      return this.allowedProductImageFormats.indexOf(ext) > -1
    },
    onInvalidProductImage(payload) {
      const file = payload && payload.file ? payload.file : payload
      const ext = (payload && payload.extension) || this.getProductImageExtension(file) || 'نامشخص'
      toast(
          'فرمت تصویر نامعتبر است',
          `فرمت «${ext}» مجاز نیست. فرمت‌های قابل قبول: jpeg, jpg, png, bmp, gif, svg, webp, avif`,
          'danger'
      )
    },
    setImages(value) {
      for (let i = 0; i < value.length; i++) {
        const file = value[i];
        if (!this.isAllowedProductImage(file)) {
          this.onInvalidProductImage(file)
          continue
        }
        this.form.images.push(file)
      }
    },
    removeTempImage(value) {
      this.form.images.splice(value, 1)
    },
    variationSwitchChange() {
      // if variation was change on update mode we save it to database.
      if (this.$route.params.slug !== undefined) {
        this.onSubmit();
      }
    },
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    calculateDiscount() {
      // محاسبه تخفیف بر اساس درصد وارد شده و قیمت اصلی
      this.form.discount = (this.form.price * this.form.discountPercentage) / 100;
    },
    calculatePercentOfDiscount() {
      if (this.form.discount > 0) {
        this.form.discountPercentage = (this.form.discount * 100) / this.form.price; // تنظیم درصد تخفیف به صفر
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("Category/getDashboardCategories");
    await this.$store.dispatch("Brand/getBrands");
    await this.$store.dispatch("Feature/getFeatures");
    const routerLink = this.$route.params.slug;
    if (routerLink !== undefined) {

      await this.setComponentForm()


    } else {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      document.getElementById(`language_item_${language_id}`).click();

    }
  },
  destroyed() {
    this.$store.commit('Reservation/setReservationRule', {})
  }
};
</script>

<style scoped>
.product-studio {
  --ink: #1e1e1e;
  --ink-soft: #424242;
  --muted: #6b6b6b;
  --line: rgba(30, 30, 30, 0.1);
  --surface: rgba(255, 255, 255, 0.94);
  --dash-primary: var(--primary, #eb3d60);
  --dash-primary-soft: rgba(235, 61, 96, 0.12);
  --dash-secondary: var(--secondary, #1e1e1e);
  --accent: var(--dash-primary);
  --accent-deep: #d12d50;
  --accent-soft: var(--dash-primary-soft);
  --danger: #dc2530;
  --shadow: 0 14px 40px rgba(30, 30, 30, 0.07);
  --radius: 20px;
  position: relative;
  min-height: 100%;
  width: calc(100% + 28px);
  max-width: none;
  margin: -14px;
  padding: 0 0 5.5rem;
  color: var(--ink);
  background:
      radial-gradient(circle at 10% 0%, rgba(235, 61, 96, 0.1), transparent 36%),
      radial-gradient(circle at 92% 8%, rgba(30, 30, 30, 0.05), transparent 30%),
      linear-gradient(180deg, #f6f6f8 0%, #fafafa 52%, #f3f3f5 100%);
}

.product-studio__ambient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
      linear-gradient(rgba(30, 30, 30, 0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(30, 30, 30, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.28), transparent 80%);
}

.product-studio__shell {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin: 0 !important;
}

.studio-topbar,
.studio-pagehead {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
  padding: 0.35rem 0.25rem 0;
}

.studio-eyebrow {
  margin: 0 0 0.35rem;
  color: var(--dash-primary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.studio-title {
  margin: 0;
  font-size: clamp(1.45rem, 2.4vw, 2rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.studio-topbar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.studio-chip,
.studio-ghost-btn,
.studio-soft-btn,
.studio-icon-btn,
.studio-primary-btn,
.studio-secondary-btn,
.studio-danger-btn {
  border: 0;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.studio-chip {
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  font-size: 0.86rem;
  font-weight: 600;
}

.studio-chip--accent {
  background: var(--dash-primary-soft);
  color: var(--accent-deep);
  border-color: transparent;
}

.studio-chip:hover,
.studio-ghost-btn:hover,
.studio-soft-btn:hover,
.studio-icon-btn:hover,
.studio-primary-btn:hover,
.studio-secondary-btn:hover {
  transform: translateY(-1px);
}

.studio-form {
  display: grid;
  gap: 0.75rem;
}

.studio-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.studio-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--line);
  background:
      linear-gradient(120deg, rgba(235, 61, 96, 0.08), transparent 46%),
      #fff;
}

.studio-panel__title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 800;
  color: var(--ink);
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.studio-panel__title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 10px;
  background: rgba(235, 61, 96, 0.12);
  color: var(--dash-primary, #eb3d60);
  font-size: 0.95rem;
  flex: 0 0 auto;
}

.studio-panel__hint {
  margin: 0.35rem 0 0;
  color: var(--muted);
  font-size: 0.86rem;
  line-height: 1.6;
}

.studio-step {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: var(--dash-secondary);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
}

.studio-panel__body {
  padding: 0.9rem 1rem 1rem;
}

.studio-panel__tools {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.studio-subtitle {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ink-soft);
  display: flex;
  align-items: center;
}

.studio-label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.55rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.studio-label--link {
  cursor: pointer;
}

/* Basics: side by side */
.studio-basics {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  align-items: start;
}

.studio-basics--with-side {
  grid-template-columns: minmax(0, 1.7fr) minmax(260px, 0.85fr);
}

.studio-basics__main,
.studio-basics__side {
  min-width: 0;
}

.studio-basics__side {
  display: grid;
  gap: 0.9rem;
}

.studio-status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.35rem;
}

.studio-status-chip {
  flex: 1 1 220px;
  min-width: 200px;
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 0.65rem 0.9rem;
  border-radius: 14px;
  background: #f7f7f8;
  border: 1px solid rgba(30, 30, 30, 0.08);
}

.studio-status-chip--digital {
  background: rgba(235, 61, 96, 0.08);
  border-color: rgba(235, 61, 96, 0.16);
}

.studio-status-chip >>> .col-lg-2,
.studio-status-chip >>> .col-12,
.studio-status-chip >>> [class*="col-"] {
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 100% !important;
  padding: 0 !important;
}

.studio-flag {
  display: flex;
  align-items: center;
  padding: 1rem 1.1rem;
  border-radius: 16px;
  background: var(--dash-primary-soft);
  border: 1px solid rgba(235, 61, 96, 0.16);
  min-height: 64px;
}

.studio-meta-stack {
  display: grid;
  gap: 0.85rem;
}

.studio-ghost-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.8rem 1rem;
  border-radius: 14px;
  background: #fff;
  border: 1px dashed rgba(235, 61, 96, 0.4);
  color: var(--accent-deep);
  font-weight: 700;
}

.studio-qr {
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-radius: 18px;
  background: #fff;
  border: 1px solid var(--line);
}

.studio-qr-card {
  display: grid;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: 18px;
  background: #fff;
  border: 1px solid var(--line);
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
}

.studio-qr-card__preview {
  display: flex;
  justify-content: center;
  padding: 0.85rem;
  border-radius: 16px;
  background: #f7f7f8;
}

.studio-qr-card__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--ink);
}

.studio-qr-card__hint {
  margin: 0.35rem 0 0.75rem;
  color: var(--muted);
  font-size: 0.82rem;
}

/* Media */
.studio-media-grid {
  display: grid;
  grid-template-columns: minmax(220px, 0.85fr) minmax(0, 1.6fr);
  gap: 1.15rem;
}

.studio-media-block {
  padding: 1.1rem;
  border-radius: 18px;
  background: #fafafa;
  border: 1px solid var(--line);
}

.studio-media-icon {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  margin-left: 0.4rem;
  border-radius: 8px;
  background: rgba(235, 61, 96, 0.12);
  color: var(--dash-primary);
  vertical-align: middle;
}

.studio-picker-card__tools {
  display: flex;
  gap: 0.4rem;
  align-items: center;
}

/* Identity: equal picker cards */
.studio-identity-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.15rem;
  align-items: stretch;
}

.studio-identity__extra {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.15rem;
  margin-top: 1.15rem;
}

.studio-picker-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 500px;
  max-height: 500px;
  padding: 1.05rem;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(30, 30, 30, 0.1);
  box-shadow: 0 8px 24px rgba(30, 30, 30, 0.04);
}

.studio-picker-card--auto {
  height: auto;
  max-height: none;
}

.studio-picker-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  flex: 0 0 auto;
}

.studio-mini-btn {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(30, 30, 30, 0.1);
  border-radius: 10px;
  background: #f6f6f7;
  color: var(--ink-soft);
  display: grid;
  place-items: center;
  cursor: pointer;
  flex: 0 0 auto;
}

.studio-mini-btn:hover {
  background: var(--dash-primary-soft);
  color: var(--dash-primary);
}

.studio-picker-card__selected {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-bottom: 0.75rem;
  flex: 0 0 auto;
}

.studio-tags__empty {
  margin: 0 0 0.75rem;
  color: var(--muted);
  font-size: 0.86rem;
  flex: 0 0 auto;
}

.studio-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  border: 0;
  background: #2a2a2a;
  color: #fff;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.studio-tag--primary {
  background: var(--dash-primary);
}

.studio-tag span {
  opacity: 0.75;
}

.studio-picker-card__body {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 14px;
  background: #f5f5f6;
  border: 1px solid rgba(30, 30, 30, 0.08);
}

.studio-picker-card__body > * {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.studio-picker-card__body >>> .col-md-6,
.studio-picker-card__body >>> [class*="col-"] {
  max-width: 100% !important;
  flex: 0 0 100% !important;
  width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.studio-picker-card__body >>> .form-group {
  width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  min-height: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.studio-picker-card__body >>> .form-group > div {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.studio-picker-card__body >>> .alert,
.studio-picker-card__body >>> .overflow_div,
.studio-picker-card__body >>> .tag-filter-1,
.studio-picker-card__body >>> .b-alert,
.studio-picker-card__body >>> .product-subscription-manager,
.studio-picker-card__body >>> .product-subscription-manager .overflow_div {
  width: 100% !important;
  max-width: 100% !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  margin: 0 !important;
  border-radius: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: var(--ink) !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.studio-picker-card__body--category {
  flex: 0 0 auto;
  height: 340px;
  max-height: 340px;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.studio-picker-card__body--category > * {
  position: static !important;
  inset: auto !important;
  width: 100% !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.studio-picker-card__body--category >>> .col-md-6,
.studio-picker-card__body--category >>> [class*="col-"],
.studio-picker-card__body--category >>> .form-group,
.studio-picker-card__body--category >>> .form-group > div,
.studio-picker-card__body--category >>> .alert,
.studio-picker-card__body--category >>> .overflow_div,
.studio-picker-card__body--category >>> .b-alert,
.studio-picker-card__body--category >>> .b-form-group {
  position: static !important;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  max-height: none !important;
  min-height: 0 !important;
  overflow: visible !important;
  display: block !important;
  flex: none !important;
}

.studio-picker-card__body--category >>> .alert.overflow_div,
.studio-picker-card__body--category >>> .overflow_div {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.studio-picker-card__body--category >>> .selected-category-section {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #ececed;
}

.studio-picker-card__body--subscription >>> .product-subscription-manager {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.studio-picker-card__body--subscription >>> .overflow_div {
  flex: 1 1 auto;
  overflow-y: auto !important;
}

.studio-picker-card__body >>> .selected_brand {
  display: none !important;
}

.studio-picker-card__body >>> .selected-category-section > span.badge,
.studio-picker-card__body >>> .selected-subscriptions > span.badge {
  display: none !important;
}

.studio-picker-card__body >>> .search-section,
.studio-picker-card__body >>> .selected-category-section > .col-12,
.studio-picker-card__body >>> .selected-subscriptions {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 0.75rem;
  background: #ececed;
  border-bottom: 1px solid rgba(30, 30, 30, 0.08);
}

.studio-picker-card__body >>> .search-section p,
.studio-picker-card__body >>> .alert > label,
.studio-picker-card__body >>> .overflow_div > label,
.studio-picker-card__body >>> .b-form-group > label,
.studio-picker-card__body >>> .selected-category-section label {
  display: none;
}

.studio-picker-card__body >>> .form-check-label,
.studio-picker-card__body >>> label {
  cursor: pointer;
  color: var(--ink-soft);
}

.studio-picker-card__body >>> .form-control,
.studio-picker-card__body >>> input[type="text"] {
  border-radius: 12px !important;
  border-color: rgba(30, 30, 30, 0.12) !important;
  background: #fff !important;
}

/* Pricing fields */
.studio-fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.studio-fields--compact {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.studio-field {
  min-width: 0;
  padding: 0.95rem;
  border-radius: 16px;
  background: #fafafa;
  border: 1px solid var(--line);
}

.studio-field__preview {
  display: block;
  margin-top: 0.35rem;
  color: var(--dash-primary);
  font-weight: 700;
  font-size: 0.9rem;
  direction: ltr;
  text-align: left;
}

.studio-field__note {
  margin: 0.45rem 0 0;
  color: var(--muted);
  font-size: 0.78rem;
  line-height: 1.55;
}

.studio-soft-btn,
.studio-icon-btn {
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--ink);
  font-weight: 700;
}

.studio-icon-btn {
  width: 2.3rem;
  height: 2.3rem;
  padding: 0;
  display: grid;
  place-items: center;
  background: var(--dash-primary);
  color: #fff;
  border-color: transparent;
}

.studio-select {
  display: block;
  width: min(100%, 320px);
  height: 46px;
  padding: 0.55rem 0.9rem;
  border-radius: 14px;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--ink);
  font-weight: 600;
}

.studio-collapse,
.studio-description {
  margin-top: 1rem;
}

.studio-editor {
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid rgba(30, 30, 30, 0.12);
  background: #fff;
  box-shadow: 0 10px 28px rgba(30, 30, 30, 0.05);
}

.studio-editor__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  background: linear-gradient(180deg, #f7f7f8, #efeff1);
  border-bottom: 1px solid rgba(30, 30, 30, 0.1);
}

.studio-editor__bar-label {
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.studio-editor__bar >>> .iframe-editor-tool {
  flex: 1 1 280px;
}

.studio-editor__canvas {
  background: #fff;
}

.studio-editor__canvas >>> .tox-tinymce {
  border: 0 !important;
  border-radius: 0 !important;
}

.studio-table-wrap {
  width: 100%;
  overflow-x: auto;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: #fff;
}

.studio-table {
  width: 100%;
  margin: 0;
  text-align: center;
  border-collapse: collapse;
}

.studio-table th,
.studio-table td {
  padding: 0.85rem 0.65rem;
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}

.studio-table thead th {
  background: rgba(235, 61, 96, 0.06);
  color: var(--ink-soft);
  font-size: 0.84rem;
}

.studio-actions {
  position: sticky;
  bottom: 0.75rem;
  z-index: 20;
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 0.75rem;
  padding: 0.9rem;
  border-radius: 20px;
  background: rgba(30, 30, 30, 0.94);
  box-shadow: 0 18px 40px rgba(30, 30, 30, 0.28);
  backdrop-filter: blur(12px);
}

.studio-actions--single {
  grid-template-columns: 1fr;
}

.studio-primary-btn,
.studio-secondary-btn,
.studio-danger-btn {
  min-height: 50px;
  border-radius: 999px;
  font-weight: 800;
}

.studio-primary-btn {
  background: var(--dash-primary);
  color: #fff;
  box-shadow: 0 10px 24px rgba(235, 61, 96, 0.32);
}

.studio-primary-btn:hover {
  background: var(--accent-deep);
  box-shadow: 0 12px 28px rgba(235, 61, 96, 0.38);
}

.studio-secondary-btn {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.28);
}

.studio-secondary-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.studio-danger-btn {
  background: rgba(220, 37, 48, 0.1);
  color: var(--danger);
  border: 1px solid rgba(220, 37, 48, 0.18);
  padding: 0.65rem 1rem;
  border-radius: 14px;
  font-weight: 700;
}

.studio-modal h5 {
  font-weight: 800;
}

.studio-modal p,
.studio-modal h6 {
  color: var(--muted);
}

@media (min-width: 1400px) {
  .studio-fields,
  .studio-fields--compact {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media (max-width: 1199.98px) {
  .studio-basics,
  .studio-basics--with-side {
    grid-template-columns: 1fr;
  }

  .studio-identity-grid {
    grid-template-columns: 1fr;
  }

  .studio-picker-card {
    height: 420px;
    max-height: 420px;
  }
}

@media (max-width: 991.98px) {
  .studio-basics,
  .studio-basics--with-side,
  .studio-media-grid,
  .studio-identity__extra {
    grid-template-columns: 1fr;
  }

  .studio-fields,
  .studio-fields--compact {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .product-studio {
    padding: 0 0 5.5rem;
  }

  .product-studio__shell {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .studio-topbar,
  .studio-pagehead {
    align-items: stretch;
    padding: 0.25rem 0.5rem 0;
  }

  .studio-topbar__actions {
    width: 100%;
  }

  .studio-chip {
    flex: 1 1 auto;
    text-align: center;
  }

  .studio-panel__head,
  .studio-panel__body {
    padding: 0.75rem 0.7rem;
  }

  .studio-fields,
  .studio-fields--compact {
    grid-template-columns: 1fr;
  }

  .studio-select {
    width: 100%;
  }

  .studio-actions {
    grid-template-columns: 1fr;
    bottom: 0.5rem;
    margin: 0;
    border-radius: 18px;
  }

  .studio-identity-grid {
    grid-template-columns: 1fr;
  }

  .studio-picker-card {
    height: 360px;
    max-height: 360px;
  }

  .studio-editor__bar {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
